import { eachDayOfInterval, startOfWeek, endOfWeek, format } from 'date-fns';
import React from 'react';
import { Day } from './Day.esm.js';

function Week(_a) {
    var activeDate = _a.activeDate, hoverDate = _a.hoverDate, max = _a.max, min = _a.min, onHoverDateChange = _a.onHoverDateChange, onSelectedDateChange = _a.onSelectedDateChange, selectedDate = _a.selectedDate, dateRange = _a.dateRange, week = _a.week, weekStartsOn = _a.weekStartsOn;
    var days = eachDayOfInterval({
        start: startOfWeek(week, { weekStartsOn: weekStartsOn }),
        end: endOfWeek(week, { weekStartsOn: weekStartsOn })
    });
    return (React.createElement("div", { role: "row", className: "tw-flex" }, days.map(function (day, index) { return (React.createElement(Day, { key: format(day, "PP"), activeDate: activeDate, day: day, hoverDate: hoverDate, index: index, max: max, min: min, onHoverDateChange: onHoverDateChange, onSelectedDateChange: onSelectedDateChange, selectedDate: selectedDate, dateRange: dateRange })); })));
}

export { Week };
//# sourceMappingURL=Week.esm.js.map
